/* tslint:disable */
/* eslint-disable */
/**
 * Appli métier
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: Yoda 1 & 2
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Configuration } from "../configuration"
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from "axios"
import globalAxios from "axios"
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
  replaceWithSerializableTypeIfNeeded
} from "../common"
// @ts-ignore
import {
  BASE_PATH,
  COLLECTION_FORMATS,
  type RequestArgs,
  BaseAPI,
  RequiredError,
  operationServerMap
} from "../base"
// @ts-ignore
import type { PairLocalDateLocalDate } from "../model"
/**
 * VintagesResourceApi - axios parameter creator
 */
export const VintagesResourceApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Get Acces plus vintage oldest and newest date
     * @param {string} entryDate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCurrentVintageMinMaxDate: async (
      entryDate: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'entryDate' is not null or undefined
      assertParamExists("getCurrentVintageMinMaxDate", "entryDate", entryDate)
      const localVarPath = `/vintages/thresholds`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication oauth2 required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

      if (entryDate !== undefined) {
        localVarQueryParameter["entryDate"] =
          (entryDate as any) instanceof Date
            ? (entryDate as any).toISOString().substring(0, 10)
            : entryDate
      }

      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    }
  }
}

/**
 * VintagesResourceApi - functional programming interface
 */
export const VintagesResourceApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = VintagesResourceApiAxiosParamCreator(configuration)
  return {
    /**
     *
     * @summary Get Acces plus vintage oldest and newest date
     * @param {string} entryDate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getCurrentVintageMinMaxDate(
      entryDate: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PairLocalDateLocalDate>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getCurrentVintageMinMaxDate(
        entryDate,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["VintagesResourceApi.getCurrentVintageMinMaxDate"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    }
  }
}

/**
 * VintagesResourceApi - factory interface
 */
export const VintagesResourceApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = VintagesResourceApiFp(configuration)
  return {
    /**
     *
     * @summary Get Acces plus vintage oldest and newest date
     * @param {VintagesResourceApiGetCurrentVintageMinMaxDateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCurrentVintageMinMaxDate(
      requestParameters: VintagesResourceApiGetCurrentVintageMinMaxDateRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<PairLocalDateLocalDate> {
      return localVarFp
        .getCurrentVintageMinMaxDate(requestParameters.entryDate, options)
        .then(request => request(axios, basePath))
    }
  }
}

/**
 * Request parameters for getCurrentVintageMinMaxDate operation in VintagesResourceApi.
 */
export interface VintagesResourceApiGetCurrentVintageMinMaxDateRequest {
  readonly entryDate: string
}

/**
 * VintagesResourceApi - object-oriented interface
 */
export class VintagesResourceApi extends BaseAPI {
  /**
   *
   * @summary Get Acces plus vintage oldest and newest date
   * @param {VintagesResourceApiGetCurrentVintageMinMaxDateRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public getCurrentVintageMinMaxDate(
    requestParameters: VintagesResourceApiGetCurrentVintageMinMaxDateRequest,
    options?: RawAxiosRequestConfig
  ) {
    return VintagesResourceApiFp(this.configuration)
      .getCurrentVintageMinMaxDate(requestParameters.entryDate, options)
      .then(request => request(this.axios, this.basePath))
  }
}
